import { MACRO_KEY } from "../../../defaults";

export const MACRO_WITH_TEMPLATES = [
  MACRO_KEY.ANNOUNCEMENTS,
  MACRO_KEY.BUTTON,
  MACRO_KEY.BUTTON_INLINE,
  MACRO_KEY.CARDS,
  MACRO_KEY.COUNTDOWN,
  MACRO_KEY.PANEL_SIMPLE,
  MACRO_KEY.IMAGE_SLIDER,
  MACRO_KEY.ADVANCED_TABS_GROUP,
  MACRO_KEY.TOOLTIPS_AND_FOOTNOTES,
  MACRO_KEY.PANEL_ADVANCED,
];

export const TEMPLATES_CUSTOM_WIDTH = [MACRO_KEY.CARDS];
